export default __webpack_public_path__ + "static/media/pet-preforms-1.5b7ea59a.jpg";